/**
 * Compile-time kill switch. Phase 1 ships disabled so the current pallet and
 * rate-friend workflow remains the production behavior until activation QA.
 */
export const DISPATCH_FREIGHT_PHASE1_ENABLED = false;
